// src/features/staff/staff.slice.ts
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { StaffUIState } from './staff.types'

const initialState: StaffUIState = {
  isDrawerOpen: false,
  isDetailDrawerOpen: false,
  isEditDrawerOpen: false,
  selectedStaffId: null,
  searchQuery: '',
  currentPage: 0,
  pageSize: 20,
}

export const staffSlice = createSlice({
  name: 'staffUi',
  initialState,
  reducers: {
    openDrawer: (state) => {
      state.isDrawerOpen = true
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false
    },
    openDetailDrawer: (state) => {
      state.isDetailDrawerOpen = true
    },
    closeDetailDrawer: (state) => {
      state.isDetailDrawerOpen = false
      state.selectedStaffId = null
    },
    openEditDrawer: (state) => {
      state.isEditDrawerOpen = true
      state.isDetailDrawerOpen = false
    },
    closeEditDrawer: (state) => {
      state.isEditDrawerOpen = false
      state.selectedStaffId = null
    },
    setSelectedStaffId: (state, action: PayloadAction<number | null>) => {
      state.selectedStaffId = action.payload
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    setPageSize: (state, action: PayloadAction<number>) => {
      state.pageSize = action.payload
    },
  },
})

export const {
  openDrawer,
  closeDrawer,
  openDetailDrawer,
  closeDetailDrawer,
  openEditDrawer,
  closeEditDrawer,
  setSelectedStaffId,
  setSearchQuery,
  setCurrentPage,
  setPageSize,
} = staffSlice.actions

export default staffSlice.reducer
